import React from 'react';

import CloseButton, { Variant } from '@swf/components/StarsModal/components/CloseButton';
import useSearchParams from '@swf/core/hooks/useSearchParams';
import { SaGLogo } from '@swf/poker';

import GameName from '../GameName/GameName';
import HowToPlayButton from '../HowToPlayButton/HowToPlayButton';
import type { SearchParams } from '../PrizeDistributionModal';

import styles from './Header.scss';

const Header: React.FC = () => {
  const { buyIn, gameType, promoRef } = useSearchParams<SearchParams>();

  return (
    <header data-testid="Prize-Modal-Header" className={styles.header}>
      <div className={styles.logoContainer}>
        <SaGLogo />
      </div>
      <GameName buyIn={buyIn} gameType={gameType} promoRef={promoRef} />
      <div className={styles.buttonContainer}>
        <HowToPlayButton gameType={gameType} />
      </div>
      <CloseButton variant={Variant.Light} className={styles.btnClose} />
    </header>
  );
};

export default Header;
